import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentcolor",
      "stroke-linecap": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M1 5.5h12M1 8.5h6" })
    ], -1)
  ]))]))
}
export default { render: render }